<div>
    <!-- <app-scheduler></app-scheduler> -->
    <h1>Calendar works</h1>
</div>